import Heading from 'components/heading/heading'
import styles from './page-head.module.scss'
import { cn } from 'utils/helpers'

export default function PageHead({ children, title, description }) {
    return (
        <div className={cn(styles.head, 'mb60')}>
            <div className={styles.left}>
                {children}
                <Heading tag="h1" size="30">
                    {title}
                </Heading>
            </div>
            <div
                className={styles.right}
                dangerouslySetInnerHTML={{
                    __html: description
                }}
            />
        </div>
    )
}
